import { render, staticRenderFns } from "./human-date.vue?vue&type=template&id=63579df9&"
import script from "./human-date.vue?vue&type=script&lang=js&"
export * from "./human-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports